// src/pages/PrivacyPage.tsx
import React from 'react';

const PrivacyPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 text-gray-900 dark:text-gray-100 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-3xl font-bold mb-8 text-center">Privacy Policy</h1>
        
        <div className="bg-white dark:bg-gray-800 rounded-lg shadow-md p-6 mb-8">
          <p className="mb-4">Last updated: January 18, 2024</p>
          
          <h2 className="text-2xl font-semibold mb-4">1. Information We Collect</h2>
          <p className="mb-6">
            We collect information you provide directly to us, such as when you create an account, play the game, or contact us.
          </p>

          <h2 className="text-2xl font-semibold mb-4">2. How We Use Your Information</h2>
          <p className="mb-4">We may use your information to:</p>
          <ul className="list-disc pl-6 space-y-2 mb-6">
            <li>Provide, maintain, and improve our services</li>
            <li>Personalize your experience</li>
            <li>Analyze how you use our services</li>
            <li>Communicate with you</li>
          </ul>

          <h2 className="text-2xl font-semibold mb-4">3. Information Sharing</h2>
          <p className="mb-6">
            We do not sell or share your personal information with third parties except as described in this privacy policy.
          </p>

          <h2 className="text-2xl font-semibold mb-4">4. Security</h2>
          <p className="mb-6">
            We take reasonable measures to help protect your personal information from loss, theft, misuse, and unauthorized access.
          </p>

          <h2 className="text-2xl font-semibold mb-4">5. Changes to This Policy</h2>
          <p>
            We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new policy on this page.
          </p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPage;